import { jsx as _jsx } from "react/jsx-runtime";
import { SvgCheck } from '../../index';
import { Alert, SIZE } from './Alert';
export { SIZE };
export const SuccessAlert = (props) => {
    return _jsx(Alert, { type: 'success', icon: _jsx(SvgCheck, {}), ...props });
};
//# sourceMappingURL=SuccessAlert.js.map